import React, { ReactElement, useCallback, useMemo } from 'react';
import { default as Form } from '.';
import { TypedCheckboxInput } from './CheckboxInput/CheckboxInput';

export type ISearchConfiguratorProps = {
  possibleFields: Array<{ label: string; field: string }>;
  value: Array<string>;
  onChange: (value: Array<string>) => void;
  readOnly?: boolean;
};

const SearchConfigurator = ({ onChange, value, possibleFields, readOnly }: ISearchConfiguratorProps) => {
  const onCheckboxChange = useCallback(
    (field, checkboxValue) => {
      let newValue = value ? value.slice() : [];

      if (checkboxValue === true) {
        if (!newValue.includes(field)) {
          newValue.push(field);
        }
      } else {
        newValue = newValue.filter((element) => element !== field);
      }
      onChange(newValue);
    },
    [onChange, value]
  );

  const displayValue = useMemo(() => {
    if (value && value.slice) {
      return value.slice();
    }
    return [];
  }, [value]);

  const checkboxes: Array<ReactElement> = [];
  possibleFields.forEach((searchField) => {
    checkboxes.push(
      <TypedCheckboxInput
        data-testid={`searchField_${searchField.field}`}
        id={`searchField_${searchField.field}`}
        key={searchField.field}
        label={searchField.label}
        value={displayValue.includes(searchField.field)}
        onChange={(event: any) => {
          onCheckboxChange(searchField.field, event.target.checked);
        }}
        readOnly={readOnly}
      />
    );
  });

  return (
    <Form.Fieldset cols={1 / 2}>
      <Form.Legend label="Search On" />
      {checkboxes}
    </Form.Fieldset>
  );
};

export default SearchConfigurator;
